import React, { Component } from 'react'
import Layout from '../layouts/Layout'
import { ExpandedGrid, RegularGrid, CustomGrid } from '../layouts/Grid'
import _ from 'lodash'
import CCLogo from '../images/colorcode-logo.svg'
import ButtonModal from '../components/ButtonModal'

import { Link, withPrefix } from 'gatsby'

import 'aos/dist/aos.css'
import { graphql } from 'gatsby'
import Nav from '../components/Nav'

export class AboutPageTemplate extends Component {
  render () {
    const { title } = this.props.content
    const body = this.props.body
    return (
      <>
        <PageGrid>
          <div id='privacy-page'>
            <h1> {title} </h1>
            {console.log(this.props.content)}
            <div dangerouslySetInnerHTML={{ __html: body }}></div>
          </div>
        </PageGrid>
      </>
    )
  }
}

const PageGrid = ({ children, className = '' }) => (
  <div className={`row ${className}`}>
    <div className='small-12 medium-10 large-8 large-offset-1 columns'>
      {children}
    </div>
  </div>
)

const PrivacyPage = ({ data }) => {
  const content = data.markdownRemark.frontmatter
  const body = data.markdownRemark.html
  return (
    <Layout fixed>
      <AboutPageTemplate content={content} body={body} />
    </Layout>
  )
}

export default PrivacyPage

export const privacyPageQuery = graphql`
  query AboutPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        title
      }
    }
  }
`
